import Axios from "axios";
import { SerializedError } from "@reduxjs/toolkit";

import {
  getAccessAdminToken,
  getAccessToken,
  getWorkspaceCode,
  removeAccessAdminToken,
  removeAdminInfoFromLocalStorage,
} from "./auth";
import { startProgress, stopProgress } from "../../redux/store/progress";
import { stores } from "../../App";

const axiosAdminBlob = Axios.create({
  withCredentials: true,
  headers: {
    locale: "kr-KR",
    "Accept-Language":
      window.navigator.language.toLocaleLowerCase() === "ko" ||
      window.navigator.language.toLocaleLowerCase() === "kr" ||
      window.navigator.language.toLocaleLowerCase() === "ko-kr"
        ? "ko-kr,ko;"
        : "en",
  },
  responseType: "blob",
});

axiosAdminBlob.interceptors.request.use(
  function (config) {
    stores.dispatch(startProgress());

    // 요청을 보내기 전에 수행할 일
    // ...
    const adminToken = window.location.href.includes("/admin")
      ? (getAccessAdminToken() as string | "")
      : (getAccessToken() as string | "");
    const dsdCode = getWorkspaceCode() as string | "";
    if (adminToken) {
      config.headers.set("X-FASOO-API-TOKEN", adminToken);
      if (window.eco.serviceType === "OCI") {
        config.headers.set("X-FASOO-DSDCODE", dsdCode ?? "MTECOCOMMON00001");
      }
    }

    return config;
  },
  function (error) {
    // 오류 요청을 보내기전 수행할 일
    // ...
    return Promise.reject(error);
  }
);

// 응답 인터셉터 추가
axiosAdminBlob.interceptors.response.use(
  (response) => {
    stores.dispatch(stopProgress());

    // 응답 데이터를 가공
    // ...
    return response;
  },
  async (error: any) => {
    // 오류 응답을 처리
    // ...
    stores.dispatch(stopProgress());

    let se: SerializedError;

    if (error.response) {
      const errorData = error.response.data;
      if (error.response.status === 401) {
        removeAccessAdminToken();
        removeAdminInfoFromLocalStorage();
        window.location.reload();
        return;
      }
      if (errorData.errorCode) {
        switch (errorData.errorCode) {
          case "INVALID_SESSION":
            removeAccessAdminToken();
            removeAdminInfoFromLocalStorage();
            window.location.reload();
            return;
          // 저장된 세션 삭제 후 로그인 페이지로 이동
          case "BAD_REQUEST":
          case "INTERNAL_SERVER_ERROR":
          case "INVALID_USER_ID_PWD":
          default:
            break;
        }
      }

      const data = await errorData.text();
      const resultError = JSON.parse(data);

      if (resultError) {
        se = {
          name: resultError.errorCode,
          message: resultError.errorMessage,
        };
      } else {
        se = {
          name: "INTERNAL_SERVER_ERROR",
          message: "INTERNAL_SERVER_ERROR",
        };
      }
      return Promise.reject(se);
    }

    se = {
      name: "INTERNAL_SERVER_ERROR",
      message: "INTERNAL_SERVER_ERROR",
    };

    return Promise.reject(se);
  }
);

export default axiosAdminBlob;
